import { render } from "./BSkeletonWrapper.vue?vue&type=template&id=6a4c8a78"
import script from "./BSkeletonWrapper.vue?vue&type=script&lang=js"
export * from "./BSkeletonWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__